// 정답으로 출제되는 단어 목록 (쉬운 일상 명사).
// 시도 허용 사전은 dictionary.js 이며, 이 목록은 자동으로 그쪽에도 포함된다.
// 여기에 어려운 단어를 넣으면 정답으로 나오므로, 누구나 아는 단어만 넣는다.
//
// 자모 길이 4~6칸만 실제로 쓰인다 (받침도 한 칸을 차지한다).
//   커피 → ㅋㅓㅍㅣ (4)   사랑 → ㅅㅏㄹㅏㅇ (5)   무지개 → ㅁㅜㅈㅣㄱㅐ (6)

export const ANSWER_WORDS = [
  // 음식 · 요리
  '커피', '바나나', '수박', '사과', '포도', '딸기', '참외', '자두', '감자', '고구마',
  '토마토', '오이', '가지', '호박', '배추', '버섯', '마늘', '양파',
  '고추', '당근', '보리', '기장', '두부', '김치',
  '간장', '식초', '설탕', '소금', '후추', '계란', '우유', '치즈',
  '버터', '사탕', '과자', '빵', '케이크', '도넛', '쿠키',
  '만두', '국수', '라면', '김밥', '순대',
  '어묵', '튀김', '전골', '찌개', '갈비', '치킨', '피자',
  '수프', '주스', '사이다', '콜라', '녹차', '홍차',

  // 동물
  '토끼', '너구리', '고라니', '노루', '사슴',
  '여우', '늑대', '사자', '표범', '치타', '기린', '하마',
  '판다', '고래', '상어', '가오리',
  '문어', '새우', '조개', '전복', '해파리', '거미', '개미', '나비',
  '오리', '거위',
  '참새', '까치', '타조',

  // 자연 · 날씨
  '하늘', '바다', '강물', '시내', '호수', '연못', '폭포', '계곡', '바위', '모래',
  '자갈', '흙', '산맥', '언덕', '들판', '초원', '사막', '정글', '숲속', '나무',
  '뿌리', '가지', '열매', '씨앗', '잔디', '이끼', '소나무', '단풍',
  '개나리', '장미', '튤립', '백합', '국화',
  '구름', '안개', '이슬', '서리', '우박', '번개', '천둥', '무지개', '태풍',
  '햇살', '노을', '유성', '혜성', '지구', '화성',

  // 사람 · 관계 · 감정
  '사랑', '우정', '행복', '기쁨', '슬픔', '설렘', '용기', '희망',
  '자유', '평화', '믿음', '정성', '보람', '추억', '기억', '상상', '미소',
  '눈물', '한숨', '아버지', '어머니', '삼촌', '이모', '고모', '조카',
  '언니', '오빠', '누나', '동생', '친구', '선배', '후배', '이웃', '손님', '주인',
  '학생', '의사', '경찰', '군인', '농부', '어부', '요리사',
  '가수', '배우', '화가', '작가', '기자', '판사', '기사', '목수',

  // 사물 · 생활
  '연필', '지우개', '가위', '공책', '책상', '의자', '서랍', '옷장',
  '거울', '시계', '달력', '가방', '지갑', '우산', '모자', '장갑',
  '신발', '양말', '바지', '치마', '외투', '이불', '베개', '수건', '비누',
  '칫솔', '치약', '난로',
  '냄비', '주걱', '국자', '접시', '포크', '상자',
  '바구니', '열쇠', '망치', '사다리', '걸레',

  // 장소 · 건물
  '학교', '교실', '약국', '시장', '가게', '식당',
  '카페', '극장', '공항',
  '항구', '다리', '터널', '골목', '마당', '옥상', '부엌', '거실',
  '침실', '창문', '계단', '복도', '대문', '지붕', '벽돌',

  // 탈것 · 도구
  '기차', '버스', '택시', '트럭', '요트', '헬기', '로켓',
  '수레', '마차', '썰매', '보드', '스키', '풍선', '팽이', '구슬',

  // 활동 · 개념
  '노래', '그림', '사진', '영화', '연극', '음악', '악기', '기타', '피아노',
  '드럼', '나팔', '장구', '박수', '운동', '수영',
  '씨름', '야구', '축구', '농구', '배구', '탁구', '골프',
  '등산', '낚시', '캠핑', '여행', '소풍', '휴가', '방학', '숙제', '시험', '공부',
  '수업', '발표', '토론', '회의', '약속', '초대', '선물', '편지', '엽서', '소포',
  '이야기', '소설', '만화', '동화', '시집', '신문', '잡지', '사전', '지도',

  // 시간 · 계절
  '아침', '점심', '저녁', '새벽', '한낮', '한밤', '오늘', '어제', '내일', '주말',
  '여름', '가을', '겨울', '설날', '추석', '생일', '휴일', '평일',

  // 색 · 모양 · 상태
  '주황', '노랑', '초록', '파랑', '보라', '분홍', '하양', '검정', '회색',
  '세모', '네모', '별표', '무늬', '거품', '연기',
  '얼음', '먼지', '냄새', '소리', '메아리',

  // 자주 쓰는 기본 명사 (추측으로 많이 입력되는 단어들)
  '사람', '이름', '얼굴', '머리', '이마', '코끝', '입술', '이빨',
  '어깨', '팔목', '손목', '손등', '손톱', '허리', '무릎',
  '발목', '가슴', '배꼽', '피부', '수염', '주름', '보조개',
  '마음', '생각', '고민', '걱정', '기분', '느낌', '성격', '버릇', '취미', '재주',
  '실력', '노력', '결과', '이유', '방법', '차례', '순서', '규칙', '비밀',
  '진심', '농담', '인사', '대답', '질문', '부탁', '허락', '반대', '찬성', '결정',
  '나라', '도시', '마을', '거리', '길목', '지역', '세상', '우주', '자연',
  '문화', '역사', '전통', '예술', '기술', '과학', '수학', '국어', '영어', '미술',
  '체육', '실험', '기록', '자료', '정보', '소식', '뉴스', '방송',
  '가족', '부모', '형제', '자매', '아들', '딸', '아기', '어른', '아이', '노인',
  '동전', '지폐', '가격', '할인', '봉투', '주머니', '보물',
  '구리', '유리', '종이', '가죽', '고무',
  '바늘', '단추', '지퍼', '조끼', '반지',
  '팔찌', '안경', '마스크', '헬멧', '장화',
  '바람', '땅',
  '구멍', '조각', '가루', '방울', '줄기', '무게', '높이', '깊이',
  '넓이', '길이', '크기', '모양', '개수', '숫자', '글자', '단어', '문장',

  // ── 추가 일상어 ─────────────────────────────────────────
  // 사전(dictionary.js)에 있는 단어 중 누구나 아는 것만 골라 넣었다.
  // 4칸
  '겨자', '고개', '고기', '교수', '구두', '구조', '규모', '기계', '기대', '기도',
  '기부', '나이', '다수', '대표', '도구', '도로', '메모', '모기', '무료', '미래',
  '미로', '배려', '보호', '부자', '비교', '비유', '사고', '사무', '사표', '서류',
  '세계', '세대', '소개', '소재', '소파', '수도', '수리', '수요', '시기', '시대',
  '시야', '애교', '야채', '여유', '여자', '오후', '요구', '우려', '우체', '유지',
  '이사', '자녀', '자루', '자세', '자체', '재료', '재미', '제비', '제사', '제자',
  '주기', '주사', '주소', '주제', '주차', '지혜', '차이', '채소', '처리', '초기',
  '초보', '추가', '치료', '치아', '카드', '코너', '코스', '태도', '투수', '투자',
  '파도', '폐지', '포기', '표지', '피리', '피해', '효도',
  // 5칸
  '감기', '감사', '개학', '거절', '건배', '검사', '격려', '경기', '경로', '경비',
  '경우', '경치', '계약', '계절', '고집', '고향', '공기', '공사', '공주', '공포',
  '교문', '교복', '교장', '교회', '구경', '구석', '국가', '군대', '그늘', '그물',
  '근처', '금고', '금리', '기름', '기업', '기온', '기적', '기준', '기침', '기회',
  '꼬리', '꼬마', '날개', '남매', '남자', '냉수', '노동', '노선', '논리', '놀이',
  '농사', '단계', '단체', '담배', '당시', '대장', '대중', '대학', '대화', '대회',
  '도장', '도전', '도착', '독서', '동네', '동시', '동해', '돼지', '두통', '등대',
  '마술', '마중', '마취', '매력', '매일', '매점', '맥주', '멀미', '명예', '모델',
  '모범', '모습', '모임', '목표', '무선', '무술', '무역', '무용', '문구', '문서',
  '문제', '미역', '미인', '바닥', '바둑', '박사', '배경', '배낭', '배달', '배송',
  '번호', '벌레', '벼락', '보답', '보름', '보상', '보석', '보온', '보통', '보험',
  '복사', '봉사', '부분', '부상', '부인', '부장', '부족', '부품', '분노', '분리',
  '분수', '붕대', '비단', '비상', '비용', '비율', '비판', '사건', '사업', '사정',
  '사회', '산소', '상대', '상처', '상추', '상태', '서명', '서점', '석유', '선거',
  '선수', '설계', '세금', '세탁', '소년', '소망', '소문', '소음', '소중', '소화',
  '속도', '수단', '수련', '수면', '수명', '수상', '수술', '수입', '수준', '수집',
  '수첩', '수출', '숙소', '순수', '스승', '승리', '시각', '시간', '시골', '시력',
  '시민', '시선', '시설', '시속', '시작', '시절', '시청', '시행', '식구', '식사',
  '신기', '신부', '신비', '신체', '신호', '실내', '실수', '실제', '실패', '아빠',
  '악수', '안내', '암기', '액자', '야간', '약수', '약초', '양보', '어린', '언어',
  '엄마', '업무', '여객', '여백', '여성', '연구', '연애', '연주', '염려', '영수',
  '영토', '예감', '예금', '예방', '예산', '예상', '예약', '예의', '예정', '오답',
  '오락', '온도', '요금', '요일', '용서', '용어', '우물', '우선', '우승', '우연',
  '위기', '위로', '위치', '유령', '유명', '유물', '유산', '유행', '육지', '음료',
  '의무', '의미', '의지', '이론', '이별', '이상', '이성', '이용', '이익', '이전',
  '인구', '인기', '인체', '일기', '일부', '일요', '일주', '입구', '입시', '잉크',
  '자격', '자랑', '자식', '자신', '자취', '자판', '잔치', '장래', '장사', '장소',
  '재난', '재산', '저금', '저울', '전기', '전시', '전자', '전체', '절차', '점수',
  '정리', '정치', '제목', '제안', '제출', '제품', '조건', '조상', '조언', '조용',
  '조절', '조정', '조종', '종교', '종류', '주먹', '주문', '주방', '주변', '주식',
  '주장', '주택', '준비', '중요', '증거', '지각', '지방', '지불', '지식', '지연',
  '지출', '진로', '질서', '차별', '참여', '창고', '창구', '채점', '천사', '천재',
  '철도', '청소', '체력', '체온', '체중', '초점', '총리', '최고', '추위', '추천',
  '축제', '출구', '취소', '침대', '커튼', '크림', '키위', '탁자', '탐구', '태양',
  '택배', '토양', '통계', '통로', '파일', '평가', '평소', '포장', '표면', '표정',
  '표현', '피곤', '필기', '필수', '필요', '하숙', '하천', '학기', '학자', '해결',
  '해답', '해변', '해석', '해외', '행사', '현대', '형태', '호흡', '혼자', '홍보',
  '화요', '회사', '효과', '휴식', '흥미',
  // 6칸
  '간식', '간판', '감독', '감동', '감정', '강당', '강의', '개구리', '건강', '건물',
  '견과', '결심', '결혼', '경험', '계획', '곡식', '공간', '공연', '과일', '과정',
  '광고', '국민', '궁금', '권리', '귀신', '글씨', '금색', '급식', '긴장', '낙엽',
  '난방', '날씨', '남편', '냉면', '녹색', '논문', '농장', '능력', '다리미', '단속',
  '단위', '단점', '답장', '덕분', '동물', '동안', '동양', '마무리', '만남', '만족',
  '면접', '명함', '목욕', '목적', '몸살', '문단', '문학', '물음', '민속', '민족',
  '박물', '반죽', '반찬', '발견', '발달', '발명', '발전', '방문', '방석', '방식',
  '배터리', '백성', '벌금', '범위', '변화', '별명', '병실', '본능', '북극', '불안',
  '사원', '산책', '삼각', '상금', '상담', '상식', '상점', '상품', '생명', '생물',
  '생선', '선박', '선생', '선택', '설명', '설문', '성공', '성능', '성인', '성장',
  '세월', '소원', '송편', '수확', '순간', '승객', '시원', '식물', '식탁', '신경',
  '신뢰', '신속', '신용', '신입', '신청', '실천', '심장', '심판', '싸움', '안녕',
  '안락', '안심', '안전', '압력', '앨범', '양념', '양복', '양산', '양식', '양심',
  '얼룩', '여관', '여권', '여왕', '역할', '연결', '연락', '연설', '연습', '연장',
  '연출', '열정', '영양', '영업', '영웅', '온천', '왕자', '외국', '욕심', '운명',
  '운반', '운영', '운전', '원리', '원소', '월요', '위반', '위인', '위험', '은행',
  '음식', '응답', '의견', '의심', '의욕', '인간', '인물', '인상', '인생', '인쇄',
  '인연', '인정', '인형', '일상', '일생', '일정', '임금', '입국', '입력', '입장',
  '자원', '작년', '작문', '작업', '작품', '장난', '장면', '장식', '장점', '장학',
  '재활', '전달', '전문', '전설', '전쟁', '전화', '절약', '점검', '정답', '정문',
  '정신', '정의', '정직', '존경', '졸업', '좌석', '중심', '중학', '증상', '지원',
  '직업', '직접', '진단', '진실', '진통', '진행', '짐승', '집안', '집중', '착각',
  '창의', '창작', '책방', '책임', '책장', '천장', '철학', '청년', '청춘', '최근',
  '최선', '출근', '출발', '출석', '출입', '출판', '충격', '충분', '취업', '취향',
  '친절', '칭찬', '탄생', '탈출', '통증', '통합', '통화', '퇴근', '특별', '특징',
  '판단', '편안', '편의', '평균', '평생', '품질', '풍경', '학년', '학문', '한글',
  '한복', '핵심', '행동', '행운', '헌법', '현금', '현상', '현실', '현장', '혈액',
  '협력', '화면', '화분', '화살', '화장', '확대', '환자', '회복', '회장', '훈련',
  '흔적', '희생',
];
